// TODO: Fix eslint errors.
/* eslint-disable */
import Logger from '@ffw/logger-lib';

function joiErrorParser(errors, overrides) {
  const parsedErrors = {};
  for (const id in errors) {
    const error = errors[id];
    if (overrides && overrides[error.context.key] && overrides[error.context.key][error.type]) {
      error.message = overrides[error.context.key][error.type];
    }
    if (process.env.REACT_APP_ISDEV) {
      Logger.error(error, 'dataValidator');
    }

    // Set error to parent element when nested validations are used.
    parsedErrors[error.path[0]] = error.message;
  }

  return parsedErrors;
}

function dataValidator(values, schema, context) {
  const validation = schema.validate(values, { abortEarly: false, context, stripUnknown: true });

  if (validation.error && validation.error.details.length) {
    const { details } = validation.error;
    return joiErrorParser(details, schema.errorOverrides);
  }

  return false;
}

export { dataValidator, joiErrorParser };
